const EMAIL_PATTERN = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/

/** Split a comma-separated address field ("ap@acme.com, jane@acme.com") into trimmed entries. */
export function parseEmailList(value: string): string[] {
  return value
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter(Boolean)
}

export function invalidEmails(value: string): string[] {
  return parseEmailList(value).filter((e) => !EMAIL_PATTERN.test(e))
}

export function isValidEmailList(value: string): boolean {
  const list = parseEmailList(value)
  return list.length > 0 && list.every((e) => EMAIL_PATTERN.test(e))
}
